module.exports = __webpack_public_path__ + "static/media/twenty_percent.3f47554a.png";